// extracted by mini-css-extract-plugin
export var divider = "_gf-7";
export var itemsToggle = "_gf-8";
export var mergeModal = "_gf-1";
export var optionCard = "_gf-4";
export var radioGroup = "_gf-6";
export var radioOption = "_gf-0";
export var selected = "_gf-5";
export var shipmentOptions = "_gf-2";
export var tableOptions = "_gf-3";